import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import settingsService from '../services/settingsService';

const SettingsContext = createContext();

const DEFAULT_SETTINGS = { currency: 'PKR', taxRate: 18, companyName: 'Heaven Apex' };

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchSettings = useCallback(async () => {
    const token = localStorage.getItem('erp_token');
    if (!token) {
      setSettings(DEFAULT_SETTINGS);
      setLoading(false);
      return;
    }
    try {
      const res = await settingsService.getSettings();
      if (res && res.success) {
        setSettings(res.data);
        localStorage.setItem('erp_settings', JSON.stringify(res.data));
      }
    } catch (e) {
      console.error('Fetch settings error:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [location.pathname, fetchSettings]);

  const updateSettings = async (newSettings) => {
    try {
      const res = await settingsService.updateSettings(newSettings);
      if (res && res.success) {
        setSettings(res.data);
        localStorage.setItem('erp_settings', JSON.stringify(res.data));
      }
      return res;
    } catch (e) {
      console.error('Update settings error:', e);
      throw e;
    }
  };

  const refreshSettings = () => fetchSettings();

  return (
    <SettingsContext.Provider value={{ settings, loading, updateSettings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);